import { jsx as _jsx } from "react/jsx-runtime";
import Link from "../../common/Link";
import DraggableBox from "../DraggableBox";
const DraggableLink = ({ item: { props, id, children }, elementId, ...rest }) => {
    const linkProps = {
        href: props?.link?.href || "#",
        target: props?.link?.target || "_self",
        page: props?.link?.page,
        "editor-link-label": props?.link?.label,
        "editor-link-type": props?.link?.type,
        "editor-link-page": props?.link?.page,
        repeatableId: props?.repeatableRepeater,
        repeatableItemId: props?.repeatableRepeaterItem,
    };
    return (_jsx(Link, { "editor-key": id, className: props?.className || "text-site-500 hover:text-site-600 text-base", "editor-has-childs": (children?.length > 0).toString(), ...linkProps, ...rest, children: _jsx(DraggableBox, { itemId: id, elementId: elementId, childs: children || [], itemProps: props }) }));
};
export default DraggableLink;
//# sourceMappingURL=DraggableLink.js.map